import { Button, Code, Flex, Stack, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import type { StepProps } from 'src/UI/drawer-flow/DrawerFlow';
import type { SmartCreateData } from 'src/secret-menu/smart-create/types';

export default function DoneStep({ data, close }: StepProps<SmartCreateData>) {
  return (
    <Flex direction="column" flex={1} justify="center" align="center" gap="lg">
      <Text size="displaySm" fw={FONT_WEIGHTS.medium} c="gray.10">
        Contract sent
      </Text>
      <Stack gap="xs" align="center">
        <Text c="gray.7">DocuSign envelope ID:</Text>
        <Code>{data.envelopeId}</Code>
      </Stack>
      <Button size="xl" onClick={close}>
        Close
      </Button>
    </Flex>
  );
}
